<template>
    <div class="horizontal-menu">
        <ul>
            <li><strong>公司概况</strong></li>
            <router-link tag="li" :to="{name: 'profile'}" v-bind:class="{ selected: active == 0 }">公司简介</router-link>
            <router-link tag="li" :to="{name: 'culture'}" v-bind:class="{ selected: active == 1 }">公司文化</router-link>
            <router-link tag="li" :to="{name: 'news'}" v-bind:class="{ selected: active == 2 }">新闻动态</router-link>
            <router-link tag="li" :to="{name: 'trends'}" v-bind:class="{ selected: active == 3 }">党建动态</router-link>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "SubNav",
        props: ['active']
    }
</script>

<style scoped lang="stylus">
    .horizontal-menu
        width 100%
        background-color #F5F5F5
        height 52px
        ul
            list-style none
            margin 0 auto
            width 1000px
            li
                float left
                font-size 13px
                padding 14px 20px
                margin 0 10px
                cursor pointer
                strong
                    font-size 15px
                    cursor default

        .selected
            background-color #E9E9E9
            color #EE1234
            border-bottom 3px solid #EE1234
</style>